// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.

import Image from "next/image";
import { useState } from "react";

import { Skeleton } from "@/components/ui/skeleton";
import { ImagePreview as ImagePreviewType } from "@/hub/types";

type ImagePreviewProps = {
	imagePreview: ImagePreviewType;
	src: string;

	maxWidth?: number;
	maxHeight?: number;
};

export function ImagePreview({ imagePreview, src, maxWidth, maxHeight }: ImagePreviewProps) {
	const [loaded, setLoaded] = useState(false);

	let width = imagePreview.width / imagePreview.devicePixelRatio;
	let height = imagePreview.height / imagePreview.devicePixelRatio;

	if (maxWidth && width > maxWidth) {
		height = (maxWidth / width) * height;
		width = maxWidth;
	}

	return (
		<div
			className="relative w-full overflow-hidden rounded-md"
			style={{
				maxHeight,
				mask:
					height > (maxHeight ?? Infinity)
						? "linear-gradient(to bottom, \n" +
							"      rgba(255,255,255, 1) 0,   rgba(255,255,255, 1) 80%, \n" +
							"      rgba(255,255,255, 0) 95%, rgba(255,255,255, 0) 0\n" +
							"  ) 100% 50% / 100% 100% repeat-x"
						: "none",
			}}
		>
			{!loaded && (
				<Skeleton
					className="absolute bottom-0 left-0 right-0 top-0"
					style={{
						contentVisibility: "hidden",
					}}
				/>
			)}

			<Image
				src={src}
				width={width}
				height={height}
				alt={imagePreview.caption}
				className="max-w-full"
				onLoad={() => setLoaded(true)}
			/>
		</div>
	);
}
